var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSource5(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 2.667,
    fill: "#000",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 15.5,
    height: 15.5,
    rx: 2.417,
    stroke: "#000",
    strokeOpacity: 0.1,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.864 8.177V4.073h4.047V5.16h-3.02v1.72a1.913 1.913 0 011.213-.418c.292.007.56.06.802.157.23.107.415.24.557.395.212.209.365.45.459.724.048.15.083.332.104.547.02.22.031.488.031.808 0 .493-.034.871-.104 1.135a1.82 1.82 0 01-.365.693c-.149.198-.366.378-.65.541-.278.17-.608.26-.99.266-.514 0-.985-.153-1.412-.458-.434-.313-.703-.818-.807-1.516h1.089c.118.583.48.878 1.088.885.26 0 .469-.052.625-.156.15-.1.254-.232.313-.396.062-.163.1-.34.114-.53.007-.188.01-.37.01-.548.008-.434-.06-.786-.202-1.057a.811.811 0 00-.339-.307 1.448 1.448 0 00-.557-.094 1.1 1.1 0 00-.542.135c-.163.094-.309.257-.437.49H5.864z",
    fill: "#000",
    fillOpacity: 0.6
  })));
}
export default SvgSource5;